import React from 'react'
import { capitalizeFirstLetter } from '../../../../../shared/config/utils';
import * as S from './Reviews.styles';

export interface IRating {
    experience: number
}
export interface IReview {
    firstName: string,
    lastName: string,
    image_url: string,
    message: string, 
    ratings: IRating,
    reviewcount: number,
    vehicleType: string,
}

interface IReviews {
    reviews: Array<IReview>,
    viewMore: boolean,
    onViewMore: () => void,
    showCollapsed: boolean
  }

export default function(props: IReviews) {
    const { reviews, viewMore, onViewMore, showCollapsed = true } = props;
    if (reviews && reviews.length > 0) {
        return (
            <S.Wrapper>
                <S.Title>Customer reviews</S.Title>
                <S.ContentWrapper>
                    {reviews.map((review) => {
                        const { firstName, lastName, image_url, message, ratings, reviewcount, vehicleType } = review;
                        return (
                            <S.ReviewWrapper>
                                <S.ImageWrapper>
                                    {image_url ? <S.Image src={image_url} alt="user" /> : <i className="fl icon-user blue ico30 padT5 padL5"></i>}
                                </S.ImageWrapper>
                                <S.Review itemScope itemType="https://schema.org/Review">
                                    <S.TitleWrapper>
                                        <S.ReviewTitle itemProp="author" itemScope itemType="https://schema.org/Person">
                                            <span itemProp="name">{`${firstName} ${lastName ? lastName : ''}`}</span>
                                        </S.ReviewTitle>
                                        <S.RatingReview>
                                            {/* {reviewcount > 0 && <S.ReviewCount>{`${reviewcount} review${reviewcount > 1 ? 's' : ''}  |`}</S.ReviewCount>} */}
                                            {ratings?.experience && (
                                                <S.Ratings itemProp="reviewRating" itemScope itemType="https://schema.org/Rating">
                                                    <span>
                                                        <span itemProp="ratingValue">{`${ratings?.experience} `}</span>
                                                    </span> 
                                                    /
                                                    <span itemProp="bestRating">
                                                        {` 5`}
                                                    </span> 
                                                </S.Ratings>
                                            )}
                                        </S.RatingReview>
                                    </S.TitleWrapper>
                                    <S.ReviewContent itemProp="reviewBody">{message}</S.ReviewContent>
                                    {vehicleType && <S.ReviewVehicle itemProp="itemReviewed" itemScope itemType="https://schema.org/Car">
                                        Travelled in <span itemProp="name">{capitalizeFirstLetter(vehicleType)}</span>
                                    </S.ReviewVehicle>}
                                    {/* <S.ReviewSubContent>
                                        <S.ReviewLiked>Liked </S.ReviewLiked>
                                        <S.ReviewSub>- Punctuality, behavior, Cleanliness, Seat comfort, Driving, Live tracking, AC </S.ReviewSub>
                                    </S.ReviewSubContent> */}
                                </S.Review>
                            </S.ReviewWrapper>
                        );
                    })}
                    {showCollapsed && <S.ViewMoreWrapper onClick={onViewMore}>{viewMore ? "View More" : "View Less"}</S.ViewMoreWrapper>}
                </S.ContentWrapper>
            </S.Wrapper>
        );
    }
    return null;
}